interface Props {
  width: string
  height: string
  color?: string
}

const NewWishlistEmtpyIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 28 27"
    fill="none"
  >
    <path
      d="M13.7251 25.5743C13.7251 25.5743 0.600061 17.6993 0.600061 8.51175C0.592972 6.98843 1.02785 5.49575 1.852 4.2146C2.67615 2.93346 3.85419 1.91884 5.24335 1.29372C6.63252 0.668596 8.17317 0.459799 9.67861 0.69263C11.1841 0.925461 12.5896 1.58993 13.7251 2.6055C14.8605 1.58993 16.2661 0.925461 17.7715 0.69263C19.2769 0.459799 20.8176 0.668596 22.2068 1.29372C23.5959 1.91884 24.774 2.93346 25.5981 4.2146C26.4223 5.49575 26.8571 6.98843 26.8501 8.51175C26.8501 17.6993 13.7251 25.5743 13.7251 25.5743Z"
      fill={props.color ?? 'black'}
      fillOpacity="0.35"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NewWishlistEmtpyIcon
